import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#111111] px-6 py-12 text-center pb-24 md:pb-12" data-id="element-63">
      <div className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-64">
        <p className="text-white font-bold text-[16px] mb-6" data-id="element-65">
          Biología Femenina · Método pH-ZERO
        </p>

        <div className="flex items-center justify-center gap-4 text-white/60 text-[14px] mb-6" data-id="element-66">
          <a href="#" className="hover:text-white transition-colors" data-id="element-67">
            Política de privacidad
          </a>
          <span data-id="element-68">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-69">
            Términos y condiciones
          </a>
        </div>

        <p className="text-white/60 text-[14px] mb-8" data-id="element-70">
          Contacto:{' '}
          <a href="https://instagram.com/biologiafemenina" target="_blank" rel="noopener noreferrer" className="text-white hover:underline" data-id="element-71">
            @biologiafemenina
          </a>
        </p>

        <p className="text-white/40 text-[12px] italic leading-relaxed max-w-lg mb-8" data-id="element-72">
          ⚕️ Este producto es de carácter informativo y educativo. No constituye
          consejo médico ni reemplaza la consulta con un profesional de la
          salud. Los resultados pueden variar.
        </p>

        <p className="text-white/30 text-[12px]" data-id="element-73">
          © 2026 Biología Femenina · Argentina
        </p>
      </div>
    </footer>;
}